import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GenaricNotesModule } from '@common/notes/notes.module';
import { ReMultiselectModule } from '@common/re-multiselect/re-multiselect.module';
import { PipeDirectiveModule } from '@shared-modules/pipe-directive.module';
import { ListingPrimeNgModule } from '../../my-listings/listing-primeNg.module';
import { EditTaskComponent } from './edit-task.component';

@NgModule({
  declarations: [EditTaskComponent],
  imports: [CommonModule, ListingPrimeNgModule, PipeDirectiveModule, GenaricNotesModule, ReMultiselectModule],
  exports: [EditTaskComponent],
})
export class EditTaskModule {}
